import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import classNames from "classnames"
import FormikAutoComplete from "common/components/FormikFields/FormikAutoComplete"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { useTranslation } from "react-i18next"
import useCamposPersonalizados from "../../hooks/useCamposPersonalizados"

import "./styles.scss"

const CamposPersonalizadoBoardListItem = ({
  index,
  endpointSlice = "",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  removeItem = () => {},
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { foundSuggestions, searchItems } =
    useCamposPersonalizados(endpointSlice)

  return (
    <div
      className={classNames([
        "w-100",
        {
          "border-t-1 pt-2": index !== 0,
        },
      ])}
    >
      <div className='px-3 py-2 campos-personalizados-board-list-item d-flex w-100'>
        <div className='mr-3 text-left w-50'>
          <FormikAutoComplete
            className='rounded-none w-100'
            id='name'
            name={`camposPersonalizados.${index}.clave`}
            placeholder={`${t(
              "inventario.articulos.modal.newArticle.campPersonal.placeholderField"
            )}`}
            dropdown
            completeMethod={searchItems}
            suggestions={foundSuggestions}
          />
        </div>

        <div className='text-left w-50'>
          <FormikInputText
            className='rounded-none w-100'
            id='value'
            name={`camposPersonalizados.${index}.valor`}
            placeholder={`${t(
              "inventario.articulos.modal.newArticle.campPersonal.placeholderValue"
            )}`}
          />
        </div>
        <div className='pl-3 my-auto'>
          <FontAwesomeIcon
            icon={["fal", "trash-can"]}
            className='btn-trash fa-lg pointer'
            onClick={() => removeItem(index)}
          />
        </div>
      </div>
    </div>
  )
}

export default CamposPersonalizadoBoardListItem
